module.exports = __webpack_public_path__ + "img/MemeETC (4).0b32f6af.jpeg";